import React, { useEffect, useState } from "react";
import {
  Button,
  Container,
  Grid,
  Typography
} from "@mui/material";
import AdminTable from "./AdminTable";
import { useDispatch } from "react-redux";
import CreateNewUser from "../../components/layout/CreateNewUser";
import ConfirmModal from "../../components/layout/ConfirmModal";
import { getAllUsersData } from "../../redux/actions/user";

const AdminPage = () => {
  const dispatch = useDispatch();
  const [showAddNewUser, setShowAddNewUser] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  useEffect(() => {
    dispatch(getAllUsersData());
  }, []);

  const onCloseAddNewUser = () => setShowAddNewUser(false);
  const onShowAddNewUser = () => setShowAddNewUser(true);
  const onCloseConfirmModal = () => setShowConfirmModal(false);

  const onAddNewUser = () => {
    onCloseAddNewUser();
    setShowConfirmModal(true);
  }

  return (
    <Container maxWidth="lg">
      <Grid className="page-title" display="flex" justifyContent="space-between" sx={{ my: { sm: 2, md: 5 }, marginInline: 'auto' }}>
        <Typography sx={{ color: '#fff', fontSize: '1.5rem', fontWeight: 600 }}>All Members</Typography>
        <Button color="success" variant="contained" sx={{ fontSize: '0.85rem', fontWeight: 500, padding: '10px 30px', textTransform: 'none', color: '#fff' }} onClick={onShowAddNewUser}>Create New Member</Button>
      </Grid>
      <AdminTable />
      <CreateNewUser
        visible={showAddNewUser}
        onClose={onCloseAddNewUser}
        onCreatedTicketSuccessed={onAddNewUser}
      />
      <ConfirmModal
        visible={showConfirmModal}
        onClose={onCloseConfirmModal}
        symbol="&#10004;"
        title="Success!"
        description="User has been created!"
        titleNo="Continue"
        onClickNo={onCloseConfirmModal}
      />
    </Container>
  );
}

export default AdminPage;
